import { RootState } from 'src/store';

export const getLeaderboards = (state: RootState) =>
  state?.performanceDashboard?.leaderboards;

export const getRankings = (state: RootState) =>
  state?.performanceDashboard?.rankings?.data;

export const getRankingColumns = (state: RootState) =>
  state.performanceDashboard?.rankings?.table?.columns || [];

export const getRankingsTableInfo = (state: RootState) =>
  state?.performanceDashboard?.rankings?.table;

export const getIndividualRankings = (state: RootState) =>
  state?.performanceDashboard?.rankings?.individual;

export const getRankingsMeta = (state: RootState) =>
  state?.performanceDashboard?.rankings?.meta;

export const getRankingsListViewOptions = (state: RootState) =>
  state?.performanceDashboard?.rankings?.listViewOptions;

export const getPerformanceCards = (state: RootState) =>
  state?.performanceDashboard?.performanceCards;
